import(/* webpackMode: "eager" */ "/workspace/src/app/welcome/page.tsx");
